
import React from "react";
const InvoicesIcon = (props) => {
  return (
    <div></div>
  );
}
export default InvoicesIcon;
